import { gql } from "@apollo/client";

export const getReleaseNotes = gql`
    query releaseNotes($lensId: ID!, $limit: Int!) {
        releaseNotes(input: { lensId: $lensId, limit: $limit }) {
            releaseNotes {
                releaseDate {
                    seconds
                    nanos
                }
                note
            }
        }
    }
`;
